<template>
    <div class="logisticsCompanyPage">
        <headerNotice routerName="物流公司"></headerNotice>
        <!-- 筛选条 -->
        <div class="searchBox">
            <h2 class="searchTitle">
                <i></i>
                <span>筛选查询</span>
            </h2>
            <el-form :inline="true" :model="searchForm" class="demo-form-inline searchForm">
                <el-form-item label="公司名称">
                    <el-input v-model="searchForm.logisticsName" clearable placeholder="公司名称"></el-input>
                </el-form-item>
                <el-form-item label="启用状态">
                    <el-select v-model="searchForm.status" placeholder="全部">
                        <!-- <el-option label="默认显示数" value></el-option> -->
                        <el-option label="全部" value="0"></el-option>
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="停用" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSearch">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 搜索结果列表 -->
        <div class="searchList" v-loading="loading">
            <div class="searchListHead">
                <h2 class="searchListTitle">
                    <i></i>
                    <span>数据列表</span>
                </h2>
                <div class="searchListCtl">
                    <el-button @click="addMember">添加</el-button>
                    <!-- <el-select v-model="searchListCtlForm.arrange" placeholder="排列方式">
                        <el-option label="默认排列方式" value></el-option>
                        <el-option label="按客户名" value="1"></el-option>
                        <el-option label="按业务员" value="2"></el-option>
                    </el-select> -->
                </div>
            </div>
            <div class="searchListContent">
                <el-table
                    ref="searchListTable"
                    :data="searchListTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="customerSlelectionChange"
                    border
                >
                    <!-- <el-table-column align='center' type="selection" width="55"></el-table-column> -->
                    <el-table-column align='center' prop="logisticsID" label="编号" width='150'></el-table-column>
                    <el-table-column align='center' prop="logisticsName" label="公司名称"></el-table-column>
                    <el-table-column align='center' prop="shipperCode" label="快递鸟Code"></el-table-column>
                    <el-table-column align='center' prop="createTime" label="添加时间" width='200'></el-table-column>
                    <el-table-column align='center' prop="status" label="启用状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status ==2">停用</span>
                            <span v-if="scope.row.status ==1">启用</span>
                        </template>
                    </el-table-column>
                    <el-table-column align='center' fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="editMember(scope.row)">编辑</el-button>
                            <!-- <el-button type="text" size="small">设置打印模板</el-button> -->
                            <el-button
                                type="text"
                                size="small"
                                @click="deleteLogisticsMember(scope.row)"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- <div style="margin-top: 20px; margin-left: 50px">
            <el-button :loading="btnLoading" >批量删除</el-button>
            <el-button :loading="btnLoading" >批量下架</el-button>
        </div> -->
        <!--搜索列表分页-->
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync='currentPage'
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
        ></el-pagination>
        <!-- 新增弹框 -->
        <el-dialog title="添加物流公司" :visible.sync="addFormVisible" width="50%" :close-on-click-modal="false">
            <div class="addSalesmanContent" v-loading="loading">
                <el-form
                    :inline="false"
                    ref="addForm"
                    :model="addForm"
                    label-width="120px"
                    class="addForm"
                    :rules='rules'
                >
                    <div class="formLeft">
                        <el-form-item label="公司Logo">
                            <el-upload
                                :accept='accept'
                                :headers="headers"
                                class="upload-demo"
                                :action="uploadAction"
                                :on-success="handleAddSuccess"
                                :on-change="handleChange"
                                :before-upload="beforeUpload"
                                :file-list="clientFileList"
                                :limit="1"
                                :on-exceed="handleExceed"
                            >
                                <el-button size="small" type="primary" icon="el-icon-upload2">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png格式文件，文件不能超过1MB</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="公司名称" prop='logisticsName'>
                            <el-input
                                v-model="addForm.logisticsName"
                                clearable
                                :readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="快递鸟Code" prop='shipperCode'>
                            <el-input v-model="addForm.shipperCode" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="官方电话">
                            <el-input
                                v-model="addForm.officialMobile"
                                clearable
                                :readonly="readonly"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="联系人">
                            <el-input v-model="addForm.linkman" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话">
                            <el-input v-model="addForm.mobile" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="签约客户号">
                            <el-input v-model="addForm.customerName" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="签约密码">
                            <el-input v-model="addForm.customerPwd" clearable :readonly="readonly"></el-input>
                        </el-form-item> -->
                        <el-form-item>
                            <el-button @click="addFormVisible = false">关闭</el-button>
                            <el-button :loading="btnLoading" @click="sendAddMember">提交</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!-- 编辑弹框 -->
        <el-dialog title="编辑物流公司" :visible.sync="editFormVisible" width="50%" :close-on-click-modal="false">
            <div class="addSalesmanContent" v-loading="loading">
                <el-form
                    :inline="false"
                    ref="editForm"
                    :model="editForm"
                    label-width="120px"
                    class="addForm"
                    :rules='rules'
                >
                    <div class="formLeft">
                        <el-form-item label="公司Logo">
                            <el-upload
                                :accept='accept'
                                :headers="headers"
                                class="upload-demo"
                                :action="uploadAction"
                                :on-success="handleAddSuccess"
                                :on-change="handleChange"
                                :before-upload="beforeUpload"
                                :file-list="clientFileList"
                                :limit="1"
                                :on-exceed="handleExceed"
                            >
                                <el-button size="small" type="primary" icon="el-icon-upload2">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png格式文件，文件不能超过50kb</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="公司名称" prop='logisticsName'>
                            <el-input
                                v-model="editForm.logisticsName"
                                clearable
                                :readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="快递鸟Code" prop='shipperCode'>
                            <el-input v-model="editForm.shipperCode" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="官方电话">
                            <el-input
                                v-model="editForm.officialMobile"
                                clearable
                                :readonly="readonly"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="联系人">
                            <el-input v-model="editForm.linkman" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话">
                            <el-input v-model="editForm.mobile" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="签约客户号">
                            <el-input v-model="editForm.customerName" clearable :readonly="readonly"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="签约密码">
                            <el-input v-model="editForm.customerPwd" clearable :readonly="readonly"></el-input>
                        </el-form-item> -->
                        <el-form-item label="启用状态" prop="status">
                            <el-radio-group v-model="editForm.status">
                                <el-radio :label="1">启用</el-radio>
                                <el-radio :label="2">停用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="editFormVisible = false">关闭</el-button>
                            <el-button :loading="btnLoading" @click="sendEditMember">提交</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            baseUrl: this.$store.state.ossUrl,
            accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            uploadAction: this.$store.state.apiUrl + '/api/services/app/Image/UploadHeadImg',//上传的服务器api地址
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            loading: true,
            btnLoading: false,
            totalCount: 0,//总数据条数
            maxResultCount: 10, //默认一页显示的个数,
            currentPage: 1,
            searchForm: {//搜索表单
                logisticsName: '',
                status: '0',
            },
            searchListCtlForm: {//排序
                arrange: ''
            },
            searchListTableData: [],
            clientFileList: [],
            addFormVisible: false,
            editFormVisible: false,
            addForm: {//新增表单

            },
            editForm: {//编辑
                logisticsID: '',
            },
            readonly: false,
            rules: {
                logisticsName: {required: true, message: '请输入公司名称', trigger: 'change'},
                shipperCode: {required: true, message: '请输入快递鸟Code', trigger: 'change'}
            }
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        });
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminLogistics/GetAdminLogistics",
                params: params,
                success(res) {
                    self.searchListTableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        //增加
        addMember() {
            let self = this;
            this.addFormVisible = true;

        },
        //提交增加物流公司
        sendAddMember() {
            let isOK
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    // console.log(this.addForm)
                    isOK = 1;
                } else {
                    isOK = 0;
                    console.log('error submit!!');
                    return false;
                }
            });
            console.log(isOK)
            if(!isOK) {
                return
            }
            let self = this;
            self.btnLoading = true
            let form = this.addForm;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminLogistics/CreateLogistics",
                data: form,
                success(res) {
                    // console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                    self.addFormVisible = false;
                    self.addForm = {}
                    self.$refs.addForm.resetFields()
                    self.btnLoading = false
                    self.onSearch()
                },
                fail(res) {
                    // console.log(res);
                    self.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    self.btnLoading = false
                }
            })
        },
        //编辑
        editMember(row) {
            let self = this;
            this.editFormVisible = true;
            let logisticsID = row.logisticsID;
            this.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminLogistics/GetAdminUpdateLogistics",
                params: { logisticsID: logisticsID },
                success(res) {
                    console.log(res);
                    self.editForm = res;
                    self.editForm.logisticsID = logisticsID;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        //提交编辑
        sendEditMember(row) {
            let isOK
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    // console.log(this.addForm)
                    isOK = 1
                } else {
                    isOK = 0
                    console.log('error submit!!');
                    return false;
                }
            });
            if(!isOK) {
                return
            }
            let self = this;
            self.btnLoading = true
            let form = this.editForm;
            $http.PUT({
                url: this.$store.state.apiUrl + "/api/services/app/AdminLogistics/UpdateLogistics",
                data: form,
                success(res) {
                    console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                    //关闭弹窗
                    self.editFormVisible = false;
                    //从新加载页面
                    self.onSearch()
                    self.btnLoading = false
                },
                fail(res) {
                    console.log(res);
                    self.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    self.btnLoading = false
                }
            })
        },
        //删除物流公司
        deleteLogisticsMember(row) {
            this.$confirm('此操作将永久删除该物流公司, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let self = this;
                $http.DELETE({
                    url: this.$store.state.apiUrl + "/api/services/app/AdminLogistics/DeleteBatchAdminLogistics",
                    params: { LogisticsID: row.logisticsID },
                    success(res) {
                        console.log(res);
                        self.$message({
                            type: 'success',
                            message: res.data,
                        });
                        self.onSearch()
                    },
                    fail(res) {
                        console.log(res);
                        self.$message({
                            type: 'error',
                            message: res.message,
                        });
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //搜索
        onSearch(params) {
            let self = this;
            this.searchForm.SkipCount = 0
            this.getDatas(this.searchForm)
            this.currentPage = 1
        },
        //搜索列表一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
                logisticsName: this.searchForm.logisticsName,
                status: this.searchForm.status
            };
        },
        //搜索列表跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.searchForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
        //客户列表选中
        customerSlelectionChange(val) {
            this.customerSlelection = val;
            console.log(this.customerSlelection);
        },
        handleChange(file, fileList) {
            this.clientFileList = fileList.slice(-3);
        },
        //上传图片之前
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (file.type != 'image/jpeg' && file.type != 'image/png') {
                this.$message.error('上传的图片只支持JPG/PNG 的格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },
        //图片上传成功
        handleAddSuccess(response, file, fileList) {
            console.log(response);
            this.addForm.headImgUrl = response.result.data;
            // this.headImgUrl = URL.createObjectURL(file.raw);
        },
        //图片上传数量限制提示
        handleExceed(files, fileList) {
            this.$message.warning(`只能选择上传 1 个文件`);
        },
    }
}
</script>

<style lang='scss' scoped>
.logisticsCompanyPage {
    //搜索框
    .searchBox {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchTitle {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 10px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            i {
                width: 24px;
                height: 24px;
                background: url("../../assets/imgs/search01.png");
            }
        }
        .searchForm {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 20px;
            .el-form-item {
                margin-bottom: 0;
            }
        }
    }
    //搜索列表
    .searchList {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchListHead {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;
            .searchTitle {
                i {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/imgs/search02.png");
                }
            }
            .searchListCtl {
                button,
                .el-select {
                    width: 130px;
                    margin-left: 10px;
                }
            }
        }
        .searchListContent {
            .detialSpan {
                color: #ff9400;
                cursor: pointer;
            }
        }
    }
    //查看
    .addSalesmanContent {
        margin: 20px 50px;
        // border: 1px solid #c5c5c5;
        display: flex;
        flex-direction: column;
        align-items: center;
        .editTitle {
            height: 40px;
            line-height: 40px;
            align-self: normal;
            margin-bottom: 10px;
            padding-left: 20px;
            // border-bottom: 1px solid #c5c5c5;
        }
        .addForm {
            display: flex;
            .formLeft {
                margin-right: 20px;
            }
            .formRight {
                margin-left: 20px;
                img {
                    width: 220px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.logisticsCompanyPage {
    .el-dialog__header {
        background: #efefef;
        border-bottom: 1px solid #c5c5c5;
    }
    .addSalesmanContent {
        .addForm {
            .formLeft {
                .el-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>